/**
 * Design Tokens - Typography
 *
 * Fonts loaded via Google Fonts in global.css:
 *  - Syne       → display / headings  (geometric, strong)
 *  - Space Grotesk → body / UI text   (modern sans)
 *  - DM Mono    → monospace / code / labels
 */

export const typography = {
  fontFamily: {
    display: "'Syne', sans-serif",
    body: "'Space Grotesk', sans-serif",
    mono: "'DM Mono', monospace",
    // Fallback system stack
    system: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },

  fontSize: {
    xs: '0.6875rem',  // 11px  - micro labels, badges
    sm: '0.8125rem',  // 13px  - captions, helper text
    base: '0.9375rem',  // 15px  - body copy
    md: '1rem',       // 16px  - default ui
    lg: '1.125rem',   // 18px  - emphasis body
    xl: '1.25rem',    // 20px  - sub-headings
    '2xl': '1.5rem',    // 24px  - section headings
    '3xl': '1.875rem',  // 30px  - page headings
    '4xl': '2.25rem',   // 36px  - display
    '5xl': '3rem',      // 48px  - hero
    '6xl': '3.75rem',   // 60px  - hero XL
    '7xl': '4.5rem',    // 72px  - marketing hero
  },

  fontWeight: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900,
  },

  lineHeight: {
    none: 1,
    tight: 1.15,
    snug: 1.3,
    normal: 1.5,
    relaxed: 1.7,
    loose: 2,
  },

  letterSpacing: {
    tighter: '-0.04em',
    tight: '-0.02em',
    normal: '0em',
    wide: '0.04em',
    wider: '0.08em',
    widest: '0.16em',
    ultra: '0.24em',  // for ALL-CAPS mono labels
  },
} as const;
